import React, { useState } from 'react';
import PlatformCard from '../ui/PlatformCard';
import AdMetricsChart from '../charts/AdMetricsChart';
import { CompetitorData } from '../../types/dataTypes';
import { Facebook, Linkedin, Search } from 'lucide-react';

interface AdPlatformsSectionProps {
  data: CompetitorData;
}

const AdPlatformsSection: React.FC<AdPlatformsSectionProps> = ({ data }) => {
  const [activePlatform, setActivePlatform] = useState('facebook');
  
  const platforms = [
    { 
      id: 'facebook', 
      name: 'Facebook/Meta Ads', 
      icon: <Facebook className="text-blue-600 dark:text-blue-400" size={24} />,
      description: 'Facebook and Instagram ad performance metrics'
    },
    { 
      id: 'linkedin', 
      name: 'LinkedIn Ads', 
      icon: <Linkedin className="text-blue-600 dark:text-blue-400" size={24} />,
      description: 'Professional network ad performance'
    },
    { 
      id: 'google', 
      name: 'Google Ads', 
      icon: <Search className="text-blue-600 dark:text-blue-400" size={24} />,
      description: 'Search and display ad metrics'
    }
  ];

  return (
    <section>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          Ad Platform Performance
        </h2>
        <div className="flex space-x-2">
          <select 
            className="bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 rounded-md shadow-sm text-sm px-3 py-1.5 focus:ring-blue-500 focus:border-blue-500"
          >
            <option>Impressions</option>
            <option>Clicks</option>
            <option>Conversions</option>
            <option>CTR</option>
            <option>CPC</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        {platforms.map((platform) => (
          <PlatformCard
            key={platform.id}
            title={platform.name}
            description={platform.description}
            icon={platform.icon}
            isActive={activePlatform === platform.id}
            onClick={() => setActivePlatform(platform.id)}
          />
        ))}
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 transition-all duration-300 transform hover:shadow-lg">
        <AdMetricsChart 
          platform={activePlatform} 
          data={data} 
        />
      </div>
    </section>
  );
};

export default AdPlatformsSection;